import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */
import ALLOW_CORS_WHITELIST from '../allow-cors-whitelist';
export var MAX_RETRIES = 3;
export var JITTER_FACTOR = 0.1;
export var MULTIPLIER = 2;
export var WAIT_TIME_MS = 1000;
export function errorIfNotOk(_x) {
  return _errorIfNotOk.apply(this, arguments);
}
function _errorIfNotOk() {
  _errorIfNotOk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (response.ok) {
            _context.next = 8;
            break;
          }
          _context.t0 = Error;
          _context.t1 = "".concat(response.status, ": ");
          _context.next = 5;
          return response.text();
        case 5:
          _context.t2 = _context.sent;
          _context.t3 = _context.t1.concat.call(_context.t1, _context.t2);
          throw (0, _context.t0)(_context.t3);
        case 8:
          return _context.abrupt("return", response);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _errorIfNotOk.apply(this, arguments);
}
export function pullResponseTextIfNotOk(_x2) {
  return _pullResponseTextIfNotOk.apply(this, arguments);
}
function _pullResponseTextIfNotOk() {
  _pullResponseTextIfNotOk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (response.ok) {
            _context2.next = 3;
            break;
          }
          _context2.next = 3;
          return response.text();
        case 3:
          return _context2.abrupt("return", response);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _pullResponseTextIfNotOk.apply(this, arguments);
}
export function stargateFetch(input, reqOptions) {
  return fetchWithRetry({
    input: input,
    reqOptions: reqOptions,
    numRetries: 0,
    maxRetries: MAX_RETRIES,
    waitTimeMs: WAIT_TIME_MS,
    backoffFn: exponentialRandomizedBackoff
  });
}
function fetchWithRetry(_ref) {
  var input = _ref.input,
    reqOptions = _ref.reqOptions,
    _ref$numRetries = _ref.numRetries,
    numRetries = _ref$numRetries === void 0 ? 0 : _ref$numRetries,
    _ref$maxRetries = _ref.maxRetries,
    maxRetries = _ref$maxRetries === void 0 ? 0 : _ref$maxRetries,
    _ref$waitTimeMs = _ref.waitTimeMs,
    waitTimeMs = _ref$waitTimeMs === void 0 ? 0 : _ref$waitTimeMs,
    _ref$backoffFn = _ref.backoffFn,
    backoffFn = _ref$backoffFn === void 0 ? exponentialRandomizedBackoff : _ref$backoffFn;
  if (numRetries > maxRetries) {
    throw new Error("Failed to fetch ".concat(input, ": Max retries exceeded"));
  }
  var options = _objectSpread(_objectSpread({}, reqOptions), {}, {
    credentials: ALLOW_CORS_WHITELIST.includes(location.host) ? 'include' : 'same-origin'
  });
  var retryAttempt = function retryAttempt() {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(fetchWithRetry({
          input: input,
          reqOptions: reqOptions,
          numRetries: numRetries + 1,
          maxRetries: maxRetries,
          waitTimeMs: backoffFn(waitTimeMs),
          backoffFn: backoffFn
        }));
      }, waitTimeMs);
    });
  };
  return fetch(input, options).then(function (response) {
    if (response.status >= 500 && response.status <= 599) {
      return retryAttempt();
    }
    return response;
  }).catch(function () {
    return retryAttempt();
  });
}
export function exponentialRandomizedBackoff(waitTimeMs) {
  var nextWaitTime = waitTimeMs * MULTIPLIER;
  var jitter = nextWaitTime * JITTER_FACTOR * Math.random();
  return nextWaitTime + jitter;
}